import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-content" }
const _hoisted_2 = { id: "email" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-2",
  id: "c1"
}
const _hoisted_5 = {
  "aria-hidden": "true",
  title: "Email",
  class: "fa-layers fa-fw"
}
const _hoisted_6 = {
  class: "col-9",
  id: "c2"
}
const _hoisted_7 = {
  class: "row",
  id: "c2r2"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "container-content" }
const _hoisted_10 = { id: "phone" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  class: "col-2",
  id: "c1"
}
const _hoisted_13 = { class: "icon-wrapper" }
const _hoisted_14 = {
  "aria-hidden": "true",
  title: "Phone",
  class: "fa-layers fa-fw"
}
const _hoisted_15 = {
  class: "col-9",
  id: "c2"
}
const _hoisted_16 = {
  class: "row",
  id: "c2r2"
}
const _hoisted_17 = ["href"]

import ModalSmall from "@/components/shared/ModalSmall.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import useApplicationData from "@/composables/useApplicationData";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

useStore();

const { tollFreeNumber, hrefTFN, emailAddress } = useApplicationData();

const emit = __emit;

function close(event: any) {
  emit("close", event);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createBlock(ModalSmall, {
    class: "support-modal",
    closeBtn: true,
    onClose: close
  }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("We're here to help", -1)
    ]))]),
    postheader: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createTextVNode("Our concierge team is available by:", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_font_awesome_layers, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: "fa-regular fa-circle",
                        class: "circle",
                        size: "10x"
                      }),
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: "fa-solid fa-envelope",
                        class: "icon",
                        transform: "shrink-6"
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "row",
                  id: "c2r1"
                }, [
                  _createElementVNode("h2", {
                    class: "subheader",
                    id: "c2r1"
                  }, "Email")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "email-link",
                    href: `mailto:${_unref(emailAddress)}`
                  }, _toDisplayString(_unref(emailAddress)), 9, _hoisted_8)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_font_awesome_layers, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-regular fa-circle",
                          class: "circle",
                          size: "10x"
                        }),
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-phone",
                          class: "icon",
                          transform: "shrink-7"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  class: "row",
                  id: "c2r1"
                }, [
                  _createElementVNode("h2", { class: "subheader" }, "Phone")
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", {
                    class: "phone",
                    href: `tel:${_unref(hrefTFN)}`
                  }, _toDisplayString(_unref(tollFreeNumber)), 9, _hoisted_17)
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", {
                  class: "row",
                  id: "c2r3"
                }, [
                  _createElementVNode("span", { class: "textAlignLeft" }, "Agents are available by phone 24 hours a day, 7 days a week.")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})